(function ($, Drupal) {
  /**
   * Leadership collapsables.
   */
   Drupal.behaviors.kinaxisLeadershipCollapse = {
    attach: function (context, settings) {
      $(once('kinaxisLeadershipCollapse', 'article.leadership')).each(function () {    
        $('.leadership-readmore').on('show.bs.collapse', function () {
          $(this).siblings('.leadership-readmore-control').find('.material-icons').animate({ deg: 180 }, {
            duration: 100,
            step: function (now) {
              $(this).css({ transform: "rotate(" + now + "deg)" });
              $(this).text('remove');
            }
          });
        });
        $('.leadership-readmore').on('hide.bs.collapse', function () {
          $(this).siblings('.leadership-readmore-control').find('.material-icons').animate({ deg: 0 }, {
            duration: 100,
            step: function (now) {
              $(this).css({ transform: "rotate(" + now + "deg)" });
              $(this).text('add');
            }
          });
        });
      });
    }
  }
})(jQuery, Drupal);